import { API } from "@/AppContext";

// Anonymous, PII-free partner-traffic tracking. A random session id is kept in
// localStorage only to de-duplicate a visitor across events; it identifies no one.
const SID_KEY = "cn_psid";

export function getSessionId() {
  try {
    let id = localStorage.getItem(SID_KEY);
    if (!id) {
      id = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : `s-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(SID_KEY, id);
    }
    return id;
  } catch {
    return "anon";
  }
}

function sessionId() {
  return getSessionId();
}

// Fire-and-forget. event: impression | job_detail_view | outbound_click | application
export function trackPartnerEvent({ provider, event, job_id, job_category, job_location }) {
  if (!provider || !event) return;
  const body = JSON.stringify({
    provider,
    event_type: event,
    job_id: job_id || null,
    job_category: job_category || null,
    job_location: job_location || null,
    session_id: sessionId(),
  });
  try {
    fetch(`${API}/partner-events/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* never block the UI on analytics */
  }
}
